import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import omit from 'lodash/omit';
import * as styles from './IrisPage.css';
import withReducerSaga from '../../hoc/ReducerRegistry/withReducerSaga';
import IrisReducer from '../../reducers/IrisReducer';
import IrisSaga from '../../sagas/IrisSaga';
import IrisActions from '../../actions/IrisAction';
import {
    selectShouldRender,
    selectPreferences,
    selectFeatureFlags,
    selectDeviceType,
    isPreview,
} from '../../selectors/ContextSelector';
import { selectIrisSeoMeta, selectIrisData } from '../../selectors/IrisPageSelector';
import defaultWrapperRenderer from './defaultWrapperRenderer';
import renderCurrentComponent from './renderCurrentComponent';
import generateComponentKeyString from './generateComponentKeyString';
import { recommendationSourceType } from '../../common/Constants';

const cx = classNames.bind(styles);
const gridcomponent = 'gridcomponent';

/** Zone render allows us to override or customize the component rendering in given zone * */
const findZoneRenderer = (zoneRenderers, zone) => {
    if (!zoneRenderers || !zone || !Array.isArray(zoneRenderers)) return false;

    const zoneRenderer = zoneRenderers.find((render) => {
        if (render.zone === zone) return true;
        return null;
    });
    const renderer = get(zoneRenderer, 'renderer', false);

    return renderer || false;
};

export class IrisPage extends Component {
    static defaultProps = {
        irisData: {},
        tag: 'div',
        params: {},
        actions: {},
        pageType: '',
        preferences: {},
        deviceType: {},
        featureFlags: {},
        irisComponents: {},
        irisFallbackEnabled: false,
        irisFallbackPreferences: {},
        disableIrisCall: false,
        irisPageSpecificComponents: {},
        currentURL: '',
        aggregateAPI: false,
        postProcessor: undefined,
        colWrapperRenderer: defaultWrapperRenderer,
        redirectAction: undefined,
        shouldRender: true,
        zoneRenderer: [],
        seoMetaData: {},
        theme: '',
        irisClientCall: true,
        isPreview: false,
        doNotRender: false,
    };

    /* eslint-disable react/sort-comp */
    rootLevelObjectName = 'content';

    tag = 'span';

    defaultRowClass = cx('row', 'col-12');

    irisColClassName = 'col';

    irisCompleteComponentList = {};

    static propTypes = {
        irisData: PropTypes.object,
        tag: PropTypes.string,
        preferences: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        deviceType: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        featureFlags: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        params: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        actions: PropTypes.objectOf(PropTypes.func),
        irisComponents: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        irisFallbackEnabled: PropTypes.bool,
        irisFallbackPreferences: PropTypes.object,
        disableIrisCall: PropTypes.bool,
        irisPageSpecificComponents: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        currentURL: PropTypes.string,
        aggregateAPI: PropTypes.bool,
        postProcessor: PropTypes.func,
        colWrapperRenderer: PropTypes.func,
        redirectAction: PropTypes.func,
        shouldRender: PropTypes.bool,
        doNotRender: PropTypes.bool,
        zoneRenderer: PropTypes.array,
        seoMetaData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        theme: PropTypes.string,
        irisClientCall: PropTypes.bool,
        pageType: PropTypes.bool,
        isPreview: PropTypes.bool,
    };

    componentWillMount() {
        if (!this.props.doNotRender) {
            this.irisCompleteComponentList = {
                ...this.props.irisComponents,
                ...this.props.irisPageSpecificComponents,
            };
            this.irisComponentsWithoutGrid = omit(this.irisCompleteComponentList, [gridcomponent]);
            if (isEmpty(this.props.irisData) && this.props.irisClientCall) {
                this.props.actions.getIrisTemplateData(
                    this.props.params,
                    this.props.aggregateAPI,
                    this.props.postProcessor,
                    this.props.irisFallbackEnabled,
                    this.props.irisFallbackPreferences,
                    this.props.redirectAction,
                    this.props.disableIrisCall
                );
            }
        }
    }

    // TODO: Think about this again.
    // shouldComponentUpdate() {
    //     if (!this.props.irisData) {
    //         return true;
    //     }
    //     return false;
    // }

    parseOneRow(rowData) {
        let retOneRow = null;
        // TODO: Refactor
        // props.tag or props.rowTag?
        const Tag = this.props.tag;
        const templateLocal = rowData.template || this.defaultRowClass;
        if (rowData.columns && rowData.columns.length) {
            const key = rowData.columns.map((column) => column.zoneDisplayName).join(',');
            retOneRow = (
                <Tag className={cx(templateLocal)} key={key}>
                    {this.oneRowGen(rowData)}
                </Tag>
            );
        } else {
            /* istanbul ignore next */
            console.warn('IRIS: columns not found in response');
        }
        return retOneRow;
    }

    oneRowGen(rowData) {
        const fullColumn = [];
        // TODO: Refactor: Should we use lodash to keep the code cleaner
        /* istanbul ignore else */
        if (rowData.columns && rowData.columns.length) {
            rowData.columns.forEach((oneCol, index) => {
                fullColumn.push(
                    <div
                        key={oneCol.zone || oneCol.zoneDisplayName || index}
                        className={cx(this.irisColClassName)}
                    >
                        {this.renderComponents(oneCol)}
                    </div>
                );
            }, this);
        } else {
            console.warn('IRIS: columns not found in response');
        }
        return fullColumn;
    }

    renderComponents(oneCol) {
        const { preferences, featureFlags, deviceType, pageType, isPreview, params } = this.props;
        const propsData = {
            preferences,
            featureFlags,
            deviceType,
            pageType,
            isPreview,
        };
        let sourceUrlFound = null;
        if (!isEmpty(params)) {
            const sourceUrl = params;
            const splitUrl = sourceUrl.split('&');
            sourceUrlFound =
                splitUrl &&
                splitUrl.find((element) => element.includes(recommendationSourceType.Source));
        }
        const colDom = [];
        /* istanbul ignore else */
        // in case of zoneRenderer though components length is 0 but we are still pushing some components
        if (oneCol.components && (oneCol.components.length || this.props.zoneRenderer)) {
            // Page can supply the wrapper html if they need to render
            const wrapperRenderer = this.props.colWrapperRenderer;
            const zoneRenderer = findZoneRenderer(this.props.zoneRenderer, oneCol.zone);
            // if zonerender found, collate all the component and call zone render instead
            if (zoneRenderer) {
                const renderedZoneComponents = zoneRenderer(
                    oneCol.zone,
                    oneCol.components,
                    this.irisCompleteComponentList,
                    this.irisComponentsWithoutGrid,
                    propsData
                );
                renderedZoneComponents.forEach((renderedComponent) =>
                    colDom.push(renderedComponent)
                );
            } else {
                oneCol.components.forEach((component, index) => {
                    const item = wrapperRenderer(
                        renderCurrentComponent(
                            component,
                            index,
                            this.irisCompleteComponentList,
                            this.irisComponentsWithoutGrid,
                            propsData
                        ),
                        generateComponentKeyString(component.componentType, index)
                    );
                    colDom.push(item);
                });
            }
        } else {
            console.warn('IRIS: components is missing in response');
        }
        return sourceUrlFound ? !__SERVER__ && colDom : colDom;
    }

    parseRow() {
        const rootNode = this.props.irisData[this.rootLevelObjectName];
        const fullNode = [];
        if (rootNode && !isEmpty(rootNode.rows)) {
            rootNode.rows.forEach((oneRowData, index) => {
                fullNode.push(this.parseOneRow(oneRowData, index));
            }, this);
        } else {
            console.warn('IRIS: rows not found in response');
        }
        return fullNode;
    }

    addSeoMetaTag() {
        const { seoMetaData } = this.props;
        const seoContent = seoMetaData.content || {};
        const MetaTag = this.irisCompleteComponentList.seotag.component;
        /* istanbul ignore next */
        const { preferences = {}, deviceType = {}, currentURL = '' } = this.props;
        const noIndexNoFollowRequired = seoContent.noIndexNoFollow || false;

        let seoComponent = null;

        try {
            seoComponent = (
                <MetaTag
                    data-automation-id="seoContent"
                    seoBlock={seoContent}
                    preferences={preferences}
                    deviceType={deviceType}
                    canonicalURL={currentURL}
                    noIndexNoFollowRequired={noIndexNoFollowRequired}
                />
            );
        } catch (e) {
            /* istanbul ignore next */
            console.warn('IRIS: seo meta tag not loaded, check api response');
        }

        return seoComponent;
    }

    render() {
        const { shouldRender, theme, doNotRender } = this.props;
        if (doNotRender) return null;
        return shouldRender ? (
            <div id="containerWidthIris" className={cx(styles.containerWidth, theme)}>
                {/* <LoadSVG svgPaths={[coreSprite, siteSprite]} /> */}
                {this.addSeoMetaTag()}
                {this.parseRow()}
            </div>
        ) : null;
    }
}

const mapStateToProps = (state) => ({
    seoMetaData: selectIrisSeoMeta(state),
    irisData: selectIrisData(state),
    shouldRender: selectShouldRender(state),
    featureFlags: selectFeatureFlags(state),
    preferences: selectPreferences(state),
    deviceType: selectDeviceType(state),
    isPreview: isPreview(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(IrisActions, dispatch),
});

export default withReducerSaga(
    [IrisReducer],
    [IrisSaga]
)(connect(mapStateToProps, mapDispatchToProps)(IrisPage));
